import React, { useState } from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { useUser } from '../generic/hooks/useUser'
import ProxiedServices from '../backoffice/ProxiedServices'
import CustomLanguages from '../backoffice/CustomLanguages'
import CameraControl from '../vision/cameraControl/CameraControl'

// Story 213 (C12.4, S265): Camera control is the third BACKOFFICE tab, with its own route.
export const BACKOFFICE_CAMERA_CONTROL_TAB = 2

/**
 * Backoffice route — accessible only for SUPERADMIN (D1/P5); the profile ADMIN reaches its Camera control tab only
 * (story 213, C14.3).
 * Renders a SmartNavigator with the "Proxied Services" tab.
 *
 * @param {Object} props
 * @param {number} [props.activePath] Tab shown first (story 213: BACKOFFICE_CAMERA_CONTROL_TAB for /backoffice/cameraControl)
 * @param {function(Array<Object>): void} [props.onLanguageCatalogueChanged] Hands a freshly read language
 *   catalogue to the top bar's selector, so a language registered here shows up there without a reload
 */
const MainBackoffice = ({ onLanguageCatalogueChanged, activePath = 0 }) => {
  const { t_ } = useSmartTranslation()
  const { user } = useUser()
  const [selected, setSelected] = useState(activePath)

  // Story 213 (C14.3, DR-3): the profile ADMIN reaches Camera control and nothing else of BACKOFFICE.
  if (user?.profile?.code === 'ADMIN') {
    return activePath === BACKOFFICE_CAMERA_CONTROL_TAB
      ? (
        <div>
          <SmartNavigator componentsInfo={[{ title: t_('Camera control'), component: <CameraControl />, to: '/backoffice/cameraControl' }]} selected={0} setSelected={() => {}} />
        </div>
        )
      : null
  }

  // Guard: non-SUPERADMIN users get nothing
  if (user?.profile?.code !== 'SUPERADMIN') {
    return null
  }

  // Historia 138: the languages section is one more tab BESIDE Proxied Services, never instead of
  // it, and the landing route of the Backoffice stays the one the menu already navigates to.
  const componentsInfo = [
    {
      title: t_('Proxied Services'),
      component: <ProxiedServices />
    },
    {
      title: t_('Custom languages'),
      component: <CustomLanguages onCatalogueChanged={onLanguageCatalogueChanged} />
    },
    {
      title: t_('Camera control'),
      component: <CameraControl />,
      to: '/backoffice/cameraControl'
    }
  ]

  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} selected={selected} setSelected={setSelected} />
    </div>
  )
}

export default MainBackoffice
